import axios from "axios";

const API_ROUTE = '/rest/v4/searchfilter';

export default {

    getAllFilterPresetsByConcept(concept) {
        return axios.get(API_ROUTE, {
            params: { concept: concept }
        });
    },

    createFilterPresetForConcept(data) {
        return axios.post(API_ROUTE, data);
    },

    deleteFilterPresetForConcept(id, config) {
        return axios.delete(API_ROUTE + `/${id}`, config);
    },

    putFilterPreset(data) {
        return axios.put(API_ROUTE, data);
    }
}
